export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/NoResult.8c9f291e.svg","height":180,"width":198,"blurWidth":0,"blurHeight":0};